import { useTranslation } from 'react-i18next'

import { CrownIcon } from '@phosphor-icons/react'

import { ButtonWithSpinner, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SmartTrackingPromoCard = ({ requesting, onRequest }) => {
  const { t } = useTranslation()

  return (
    <Styles.Card>
      <Styles.Header>
        <Styles.HeaderFrame>
          <Styles.HeaderScrim>
            <Text type="titleM">{t('Haz más con Smart Tracking')}</Text>
          </Styles.HeaderScrim>
        </Styles.HeaderFrame>
      </Styles.Header>
      <Styles.Body>
        <Text type="bodyXSRegular">
          {t(
            'Expande tu marca con bloques de contenido personalizado y convierte la experiencia post-compra de tus clientes en nuevas oportunidades y descubrimientos.'
          )}
        </Text>
        <ButtonWithSpinner
          fullWidth
          size="s"
          loading={requesting}
          disabled={requesting}
          defaultLabel={
            <>
              <CrownIcon size={16} />
              {t('Solicitar Smart Tracking')}
            </>
          }
          loadingLabel={t('Solicitar Smart Tracking')}
          onClick={onRequest}
        />
      </Styles.Body>
    </Styles.Card>
  )
}

export default SmartTrackingPromoCard
